import * as React from "react";
import type { SVGProps } from "react";
const SvgCocktail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 4h4.384l.997 2H5c-.37 0-.695.204-.868.505A.996.996 0 0 0 4.29 7.71L11 14.42V20H8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1h-3v-5.59l2.88-2.88c.662.31 1.384.47 2.12.47h.01c2.76 0 5-2.24 5-5a5.002 5.002 0 0 0-9.9-1h-2.49L8.9 2.56a.98.98 0 0 0-.695-.539A1 1 0 0 0 8 2H3c-.55 0-1 .45-1 1s.45 1 1 1m12.182 2a3.01 3.01 0 0 1 2.828-2c1.65 0 3 1.35 3 3a3.01 3.01 0 0 1-3.55 2.95l2.203-2.203A.999.999 0 0 0 19 6zM11.62 8l.28.56c.25.49.05 1.09-.45 1.34-.14.07-.3.11-.45.11V10c-.37 0-.72-.2-.9-.55L9.377 8H7.4l4.595 4.595L16.59 8z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCocktail;
